const prefix = 'criterias'

export const SET_CRITERIAS = `${prefix}/SET_CRITERIAS`
export const SET_SELECTED_CRITERIA = `${prefix}/SET_SELECTED_CRITERIA`
export const SET_PER_PAGE = `${prefix}/SET_PER_PAGE`
export const SET_SEARCH = `${prefix}/SET_SEARCH`
